import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

const state = {
  token: Cookies.get('admin_token') || '',
  adminInfo: null
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      Cookies.set('admin_token', token, { expires: 7 })
    } else {
      Cookies.remove('admin_token')
    }
  },
  SET_ADMIN_INFO(state, adminInfo) {
    state.adminInfo = adminInfo
  },
  CLEAR_AUTH(state) {
    state.token = ''
    state.adminInfo = null
    Cookies.remove('admin_token')
  }
}

const actions = {
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },
  setAdminInfo({ commit }, adminInfo) {
    commit('SET_ADMIN_INFO', adminInfo)
  },
  logout({ commit }) {
    commit('CLEAR_AUTH')
  }
}

const getters = {
  token: state => state.token,
  adminInfo: state => state.adminInfo,
  isLoggedIn: state => !!state.token
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
}) 